import { combineReducers } from "redux";
import customiseReducer from "./customise/customiseReducer";
import LoginReducer from "./Login/LoginReducer";
import FlexiQuoteReducer from "./FlexiQuote/FlexiQuoteReducer";
import OpportunityReducer from "./Opportunity/OpportunityReducer";
import CustomerReducer from "./Customer/CustomerReducer";
import SalesQuoteReducer from "./SalesQuote/SalesQuoteReducer";
import SalesOrderReducer from "./SalesOrder/SalesOrderReducer";
import PurchaseOrderReducer from "./PurchaseOrder/PurchaseOrderReducer";
import InvoiceRequestReducer from "./InvoiceRequest/InvoiceRequestReducer";
import SettingsReducer from "./Settings/SettingsReducer";
import ApprovalReducer from "./Approval/ApprovalReducer";
import TaskReducer from "./Tasks/TasksReducer";
import TimeSheetReducer from "./TimeSheet/TimeSheetReducer";
import EmailReducer from './Email/EmailReducer';
import ActivityReducer from "./ActivityList/ActivityReducer";
import EmployeeAdvanceReducer from "./EmployeeAdvance/EmployeeAdvanceReducer";
import CategoryReducer from "./CategoryList/CategoryReducer";
import ExpenseClaimReducer from "./ExpenseClaim/ExpenseClaimReducer";
import ExpeseSettingsReducer from "./ExpenseSettings/ExpeseSettingsReducer";
import ReportsReducer from './Reports/ReportsReducer';
import AlertMasterReducer from "./Alert/AlertMasterReducer";
import KitReducer from './Kit/KitReducer';
import SDCustomerReducer from "./APMS/Customers/CustomersReducer";
import SDProjectsReducer from "./APMS/Projects/ProjectsReducer";
import SDSubProjectsReducer from "./APMS/SubProjects/SubProjectsReducers";
import SDTicketsReducer from "./APMS/Tickets/TicketsReducer";
import SDLogWorkReducer from "./APMS/LogWork/LogWorkReducer";
import SDProductionGroupingReducer from "./APMS/ProductionGrouping/ProductionGroupingReducer";
import TripReducer from "./Trip/TripsReducer";
import PolicyReducer from "./Policies/PolicyReducer";
import supportDeskDashboardReducer from "./APMS/dashboard/dashboardReducer";
import TaskPlannerReducer from "./TaskPlanner/TaskPlannerReducer";
import GoalsReducer from "./Goals/GoalsReducer";
import DemandReducer from "./Demand/DemandReducer";
import DemandOpportunityReducer from "./DemandOpportunity/DemandOpportunityReducer";
import PredefinedGoalsReducer from "./PredefinedGoals/PredefinedGoalsReducer";
import customReportsReducer from "./custom-reports/customReportsReducer";
import scheduleReportsReducer from "./schedule-reports/scheduleReportsReducer";
import customerFeedbackReducer from "./CustomerFeedback/CustomerFeedbackReducer";

const rootReducer = combineReducers({
  customise: customiseReducer,
  login: LoginReducer,
  flexiQuote: FlexiQuoteReducer,
  opportunity: OpportunityReducer,
  customer: CustomerReducer,
  salesQuote: SalesQuoteReducer,
  salesOrder: SalesOrderReducer,
  purchaseOrder: PurchaseOrderReducer,
  invoiceRequest: InvoiceRequestReducer,
  settings: SettingsReducer,
  approval: ApprovalReducer,
  tasks: TaskReducer,
  TimeSheet: TimeSheetReducer,
  email: EmailReducer,
  Activity: ActivityReducer,
  EmployeeAdvance: EmployeeAdvanceReducer,
  Category: CategoryReducer,
  ExpenseClaim: ExpenseClaimReducer,
  expenseSettings: ExpeseSettingsReducer,
  Reports: ReportsReducer,
  Alert: AlertMasterReducer,
  Kit: KitReducer,
  SDCustomer: SDCustomerReducer,
  SDProjects: SDProjectsReducer,
  SDSubProjects: SDSubProjectsReducer,
  SDTickets: SDTicketsReducer,
  SDLogWork: SDLogWorkReducer,
  SDProductionGrouping: SDProductionGroupingReducer,
  Trip: TripReducer,
  Policy: PolicyReducer,
  supportDeskDashboard: supportDeskDashboardReducer,
  taskPlanner: TaskPlannerReducer,
  goals: GoalsReducer,
  demand: DemandReducer,
  demandOpportunity: DemandOpportunityReducer,
  predefinedGoals: PredefinedGoalsReducer,
  customReports: customReportsReducer,
  scheduleReports: scheduleReportsReducer,
  customerFeedback: customerFeedbackReducer,
});

export default rootReducer;